import {inject, Injectable} from '@angular/core';
import {OpenFilesViewerModalParams} from "../../../../types/file.types";
import {SingleFilesParamsService} from "./single-files-params.service";
import {RecordCalendarFilesService} from "../../../../services/record-calendar-files.service";
import {MultiFilesParamsService} from "./multi-files-params.service";

@Injectable({
  providedIn: 'root'
})
export class FilesCurrentService {
  private recordCalendarFilesService: RecordCalendarFilesService = inject(RecordCalendarFilesService);
  private singleFilesParamsService: SingleFilesParamsService = inject(SingleFilesParamsService);
  private multiFilesParamsService: MultiFilesParamsService = inject(MultiFilesParamsService);

  public async getFilesParams({ key, recordCalendarId, isAllFiles }: OpenFilesViewerModalParams): Promise<void> {
    if (!key) { return; }

    await this.recordCalendarFilesService.getFilesData({recordCalendarId: recordCalendarId, type: key})
      .then(recordCalendarFilesParams =>
        recordCalendarFilesParams.forEach(recordCalendarFileParams => {
          isAllFiles ?
            this.multiFilesParamsService.updateMultiFileParams(key, recordCalendarFileParams) :
            this.singleFilesParamsService.updateFilesData(recordCalendarFileParams);
        })
      );
  }
}
